import React, { useEffect, useState } from 'react';
import Cards, { getModelUrlById } from './assets/cards/cards';
import CardView from './pages/cardview/CardView';
import Collection from './pages/collection/Collection';
import Intro from './pages/intro/Intro';
import Scanner from './pages/scanner/Scanner';
import { tag } from './services/ATInternetService';
import { getCollectionCount, isCardInCollection } from './stored/Collection';
import upgrade from './stored/Upgrading';

const loadedCards = [];

const App = () => {
	upgrade();

	const [isVideoLoaded, setIsVideoLoaded] = useState(false);
	const [shouldBeScanning, setShouldBeScanning] = useState(false);
	const [scannedCard, setScannedCard] = useState(null);
	const [scannedCardString, setScannedCardString] = useState(null);
	const [shouldShowCollection, setShouldShowCollection] = useState(false);
	const [tradeQRCode, setTradeQRCode] = useState(null);

	document.getElementById('webcam__video').onloadeddata = () => {
		setIsVideoLoaded(true);
	};

	useEffect(() => { }, [scannedCardString, shouldShowCollection, shouldBeScanning]);

	Cards.forEach((card) => {
		// @ts-ignore
		if (window.model && loadedCards.indexOf(card.id) < 0) {
			fetch(getModelUrlById(card.id));
			loadedCards.push(card.id);
		}
	});

	return (
		<div className="App h-full w-full absolute top-0 left-0 overflow-hidden">
			<Intro onFinished={() => setShouldBeScanning(true)} />

			{!shouldShowCollection && (
				<>
					{shouldBeScanning && isVideoLoaded && scannedCard === null && (
						<Scanner
							onCardPlaceScanned={(card) => {
								setScannedCard(card);
								setScannedCardString(JSON.stringify(card));
								setShouldBeScanning(false);
								tag.sendClick('scanner', {
									chapter3: isCardInCollection(card.card.id) ? 'scanned-new-card' : 'scanned-collected-card',
									name: card.card.id,
								});
								tag.sendClick('scanner', {
									chapter3: 'scanned-home',
									name: card.match.class.replace(' ', '-'),
								});
								// @ts-ignore
								window.vibrate(1000);
							}}
							onRequestShowCollection={() => {
								setShouldShowCollection(true);
								tag.sendClick('scanner', {
									name:
										getCollectionCount() > 0
											? 'opened-collection'
											: 'opened-tips',
								});
							}}
							onTradeQRScanned={(value) => {
								setTradeQRCode(value);
								setShouldShowCollection(true);
							}}
						/>
					)}
					{scannedCard !== null && !shouldBeScanning && (
						<CardView
							scanned={scannedCard}
							onBackPressed={() => {
								setScannedCard(null);
								setScannedCardString(null);
								setShouldBeScanning(true);
							}}
							openCollection={() => {
								setScannedCard(null);
								setScannedCardString(null);
								setShouldShowCollection(true);
								tag.sendClick('card-view', {
									name:
										getCollectionCount() > 0
											? 'opened-collection'
											: 'opened-tips',
								});
							}}
						/>
					)}
				</>
			)}
			{shouldShowCollection && (
				<Collection
					onRequestHideCollection={() => {
						setTradeQRCode(null);
						setShouldShowCollection(false);
						setShouldBeScanning(true);
					}}
					onRequestShowCardView={(card, location) => {
						const scanObject = {
							card,
							match: {
								class: location,
							},
						};
						setTradeQRCode(null);
						setShouldShowCollection(false);
						setShouldBeScanning(false);
						setScannedCard(scanObject);
						setScannedCardString(JSON.stringify(scanObject));
					}}
					tradeQRCode={tradeQRCode}
				/>
			)}
		</div>
	);
};

export default App;
